export default function applyMappingsToClone(mappings = [], clone) {
  if (!clone) {
    return
  }

  for (const { selector, values } of mappings) {
    const element = clone.querySelector(selector)

    if (element) {
      for (const [key, value] of Object.entries(values)) {
        if (value) {
          if (key === 'dataset') {
            for (const [dataKey, dataValue] of Object.entries(value)) {
              element.dataset[dataKey] = dataValue
            }
          } else if (key === 'classList') {
            element.classList.add(...value)
          } else if (key === 'attributes') {
            for (const [dataKey, dataValue] of Object.entries(value)) {
              element.setAttribute(dataKey, dataValue)
            }
          } else {
            element[key] = value
          }
        } else if (!element[key] || (key === 'textContent' && value === null)) {
          element.remove()
        }
      }
    }
  }
}
